var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_31569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 14.1666H3.33334C1.95251 14.1666 0.833344 13.0474 0.833344 11.6666V8.33325C0.833344 6.95242 1.95251 5.83325 3.33334 5.83325H16.6667C18.0475 5.83325 19.1667 6.95242 19.1667 8.33325V11.6666C19.1667 13.0474 18.0475 14.1666 16.6667 14.1666Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 18.3334H14.5833C12.975 18.3334 11.6667 17.0251 11.6667 15.4167V4.58341C11.6667 4.35341 11.48 4.16675 11.25 4.16675H10.4167C9.72582 4.16675 9.16666 3.60758 9.16666 2.91675C9.16666 2.22591 9.72582 1.66675 10.4167 1.66675H11.25C12.8583 1.66675 14.1667 2.97508 14.1667 4.58341V15.4167C14.1667 15.6467 14.3533 15.8334 14.5833 15.8334H15.4167C16.1075 15.8334 16.6667 16.3926 16.6667 17.0834C16.6667 17.7742 16.1075 18.3334 15.4167 18.3334Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 5.83341C12.2258 5.83341 11.6667 5.27425 11.6667 4.58341C11.6667 2.97508 12.975 1.66675 14.5833 1.66675H15.4167C16.1075 1.66675 16.6667 2.22591 16.6667 2.91675C16.6667 3.60758 16.1075 4.16675 15.4167 4.16675H14.5833C14.3533 4.16675 14.1667 4.35341 14.1667 4.58341C14.1667 5.27425 13.6075 5.83341 12.9167 5.83341Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18.3334H10.4167C9.72582 18.3334 9.16666 17.7742 9.16666 17.0834C9.16666 16.3926 9.72582 15.8334 10.4167 15.8334H11.25C11.48 15.8334 11.6667 15.6467 11.6667 15.4167C11.6667 14.7259 12.2258 14.1667 12.9167 14.1667C13.6075 14.1667 14.1667 14.7259 14.1667 15.4167C14.1667 17.0251 12.8583 18.3334 11.25 18.3334Z",
    fill: "#6C6C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_31569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.85c0d393ef4a16fbd59ae2234563765f.svg";
export { ForwardRef as ReactComponent };